import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import mapStateToFormProps from 'utils/mapStateToFormProps';
import createForm from 'components/connectedForm/ConnectedForm';
import { default as Form } from 'components/connectedForm';
import * as input from 'components/connectedForm/inputComponents';
import moment from 'moment';
import EditableDataGrid from 'components/EditableDataGrid/EditableDataGrid';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const formFields = {
  textinput: null,
  toggle: null,
  dropdown: null,
  editgrid: null,
  dateinput: null,
};

const validation = {
  dropdown: {
    objectType: 'Dropdown',
  },
};

const baseColumns = [
  {
    name: 'Label',
    key: 'label',
    editable: false,
  },
  {
    name: 'Value',
    key: 'value',
    editable: false,
  },
];

const editColumns = [
  {
    name: 'Label',
    key: 'label',
    editable: true,
  },
  {
    name: 'Value',
    key: 'value',
    editable: true,
  },
];

class ComponentTests extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Form.FormContainer>
        <Form.Form>
          <Form.Field
            dataid="dropdown"
            component={input.Dropdown}
            label="Dropdown"
            options={[
              { id: 1, description: 'option 1' },
              { id: 2, description: 'option 2' },
            ]}
            valueKey="id"
            labelKey="description"
            forceReadOnly={false}
          />
          <Form.Field dataid="textinput" component={input.BlurTextField} label="Text Input" forceReadOnly={false} />
          <Form.Field dataid="toggle" component={input.Switch} label="Switch" forceReadOnly={false} />
          <Form.Field dataid="checkbox" component={input.Checkbox} label="Checkbox" forceReadOnly={false} />
          <Form.Field
            dataid="dateinput"
            component={input.DateField}
            label="Date"
            dateFormat="yyyy-MM-dd"
            startDate={moment()}
            forceReadOnly={false}
          />
          <EditableDataGrid
            rowsCount={2}
            listData={[
              { value: 'row 1 value', label: 'row 1 label' },
              { value: 'row 2 value', label: 'row 2 label' },
            ]}
            columns={baseColumns}
            forceReadOnly={false}
            contentHeight={150}
          />
          <EditableDataGrid
            rowsCount={1}
            listData={[]}
            columns={editColumns}
            addBlankRow={true}
            enableCellSelect={true}
            testId="editgrid"
            dataid="editgrid"
            forceReadOnly={false}
            contentHeight={150}
          />
          <Form.Field dataid="displaylist" component={input.DisplayList} label="Display List" forceReadOnly={false} />
        </Form.Form>
      </Form.FormContainer>
    );
  }
}

const withDragDropContext = (Component) => {
  return (props) => {
    return (
      <DndProvider backend={HTML5Backend}>
        <Component {...props} />
      </DndProvider>
    );
  };
};

export default compose(
  withDragDropContext,
  connect(mapStateToFormProps),
  createForm({
    form: 'ComponentTests',
    name: 'Component Tests',
    entity: { type: 'ComponentTests' },
    formConfig: {
      fields: formFields,
      validation: validation,
    },
  })
)(ComponentTests);
